export function getRem() {
  return parseFloat(getComputedStyle(document.documentElement).fontSize);
}

export function isMobileResolution() {
  return window.matchMedia("(max-width:768px)").matches;
}

export function isTabletResolution() {
  return window.matchMedia(
    "(max-width: 1199px) and (min-width: 769px) and (pointer: coarse)",
  ).matches;
}

export function getCookie(name: string) {
  const matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)",
    ),
  );

  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function initTextTruncate() {
  function scrollToElement(targetEl: Element) {
    const header = document.querySelector(".header");
    const headerBottom = header ? header.getBoundingClientRect().bottom : 0;
    const offset = -(headerBottom + 20);

    const rect = targetEl.getBoundingClientRect();
    window.scrollTo({
      top: rect.top + window.scrollY + offset,
      behavior: "smooth",
    });
  }
  const containers = document.querySelectorAll("[data-truncate]");
  const isMobile = window.innerWidth <= 768;

  containers.forEach((container) => {
    const textBlock = container.querySelector("[data-truncate-text]");
    const btn = container.querySelector("[data-truncate-btn]");

    if (!textBlock || !btn) return;

    // 1. Получаем настройки из атрибутов
    const linesDesktop =
      parseInt(container.getAttribute("data-truncate-lines")) || 3;
    const linesMobile =
      parseInt(container.getAttribute("data-truncate-lines-mobile")) ||
      linesDesktop;
    const targetLines = isMobile ? linesMobile : linesDesktop;

    // 2. Сброс для расчетов
    const wasCollapsed =
      container.classList.contains("is-collapsed") ||
      !container.classList.contains("is-initialized");
    textBlock.style.maxHeight = "none";

    const computedStyle = window.getComputedStyle(textBlock);
    const lineHeight = parseFloat(computedStyle.lineHeight);
    const limitHeight = Math.ceil(lineHeight * targetLines);

    // 3. Проверка на необходимость сокращения
    if (textBlock.scrollHeight > limitHeight + 3) {
      container.classList.add("is-truncated");
      container.classList.add("is-initialized");

      // Если блок был свернут (или только инициализирован), применяем ограничение
      if (wasCollapsed) {
        textBlock.style.maxHeight = `${limitHeight}px`;
        container.classList.add("is-collapsed");
        btn.textContent = btn.getAttribute("data-text-show") || "Read more";
      } else {
        // Если блок уже был открыт, обновляем до актуальной полной высоты
        textBlock.style.maxHeight = textBlock.scrollHeight + "px";
        btn.textContent = btn.getAttribute("data-text-hide") || "Collapse";
      }

      btn.style.display = "inline-block";
    } else {
      // Если текст короткий — сбрасываем всё
      container.classList.remove("is-truncated", "is-collapsed");
      btn.style.display = "none";
      textBlock.style.maxHeight = "none";
    }

    // 4. Логика клика (очищаем старый обработчик, чтобы не множить их при ресайзе)
    btn.onclick = (e) => {
      e.preventDefault();
      const isNowCollapsed = container.classList.contains("is-collapsed");

      if (isNowCollapsed) {
        textBlock.style.maxHeight = textBlock.scrollHeight + "px";
        container.classList.remove("is-collapsed");
        btn.textContent = btn.getAttribute("data-text-hide") || "Collapse";
      } else {
        textBlock.style.maxHeight = `${limitHeight}px`;
        container.classList.add("is-collapsed");
        btn.textContent = btn.getAttribute("data-text-show") || "Read more";
        scrollToElement(container);
      }

      const onHeightTransitionEnd = (event) => {
        if (event.target !== textBlock || event.propertyName !== "max-height")
          return;
        textBlock.removeEventListener("transitionend", onHeightTransitionEnd);
      };
      textBlock.addEventListener("transitionend", onHeightTransitionEnd);
      // Фолбэк, если transitionend не сработает (нет CSS-transition на max-height)
      setTimeout(() => {
        textBlock.removeEventListener("transitionend", onHeightTransitionEnd);
      }, 600);
    };
  });
}
